import React from 'react';
import StatementPageTemplate from '../StatementPageTemplate';
import Icons from '../../../../../components/Common/Icons/Icons';
import { mortgageStatementsAccordion, mortgageStatementsCol } from '../Data';
import { SEARCH_SUGGESTIONS } from '../../Notices/Data';

function MortgageStatements() {
  return (
    <StatementPageTemplate
      icon={<Icons.UserCheck />}
      title="Mortgage Statements"
      tableProps={{
        data: mortgageStatementsAccordion,
        tableCol: mortgageStatementsCol,
      }}
      searchSuggestions={SEARCH_SUGGESTIONS}
    />
  );
}

export default MortgageStatements;
